export const URL_ANATEL_PRODUCT_CERTIFICATION =
  'https://informacoes.anatel.gov.br/paineis/certificacao-de-produtos/consulta-de-produtos'
